import * as _ from "lodash";
import * as angular from "angular";
import { FileUploader } from "angular-file-upload";
import { DocumentModel } from "../../models/document.model";
import { User } from "../../models/user.model";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { UserDataProvider } from "../../data-provider/user.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { FileType } from "../../utils/interfaces";
import { ScreenUtils } from "../../helper/screen.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { DocumentDataProvider } from "../../data-provider/document.dp";
import { SearchUtils } from "../../helper/search.helper";
import { Utils } from "../../helper/utils.helper";
import { fileConstants } from "../../utils/constants/files.constants";
import { PermissionCheck } from "../../shared/permission";

let DocumentComponent = {
    selector: "vcDocuments",
    templateUrl: "/angular/components/document/document.component.html",
    bindings: {},
    controller: class DocumentController {
        private $scope: any;
        private toast: ToastUtils;
        private $timeout: any;
        private dataProvider: DocumentDataProvider;
        private dialog: DialogUtils;
        private searchUtils: SearchUtils;
        public screen: ScreenUtils;
        public navigationBarService: NavigationBarHelperService;
        public uploader: FileUploader;
        public isLeaderView: boolean;
        public readonly permissionProvider: PermissionCheck;

        public user: User;
        public loading: boolean = true;
        public hasImportAccess: boolean;
        public description: string = "";
        public search: string = "";
        public documents: DocumentModel[] = [];
        public acceptedFileTypes = [...fileConstants.acceptedFileTypes];

        constructor(
            $scope: any,
            $timeout: any,
            DocumentDataProvider: DocumentDataProvider,
            SearchUtils: SearchUtils,
            NavigationBarHelperService: NavigationBarHelperService,
            __app_type: string,
            Utils: Utils,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            ScreenUtils: ScreenUtils,
            PermissionCheck: PermissionCheck,
            UserDataProvider: UserDataProvider
        ) {
            Utils.accessCheck();
            Utils.runWootric();

            this.$scope = $scope;
            this.toast = ToastUtils;
            this.$timeout = $timeout;
            this.dataProvider = DocumentDataProvider;
            this.searchUtils = SearchUtils;
            this.navigationBarService = NavigationBarHelperService;
            this.dialog = DialogUtils;
            this.screen = ScreenUtils;
            this.permissionProvider = PermissionCheck;

            this.user = UserDataProvider.getActiveUser();
            this.navigationBarService.toggleFilterButton(true);
            this.uploader = this.dataProvider.getFileUploader(1);
            this.uploader.onWhenAddingFileFailed = (item: object) => {
                this.toast.error("File is not supported");
            };

            this.isLeaderView = __app_type == "LEADER";
            this.description = this.isLeaderView
                ? "Central repository for all your exports"
                : "Central repository for all your exports and documents";

            this.searchUtils.setSearchBar("Search Documents", (searchText) => {
                this.search = searchText;
                return [];
            });

            this.dataProvider.getDocuments(true).then(
                (documents: DocumentModel[]) => {
                    this.loading = false;
                    this.documents = documents;
                },
                () => {
                    this.loading = false;
                    this.toast.error("An error occurred loading documents.");
                }
            );

            if (this.isLeaderView) {
                this.hasImportAccess = this.permissionProvider.hasPermission(
                    "IMPORT_ORGANISATION_LEVEL"
                );
            } else {
                this.hasImportAccess = this.permissionProvider.hasPermission(
                    "IMPORT_CAMPAIGN_LEVEL"
                );
            }
        }

        clearFilters(): void {
            this.acceptedFileTypes.forEach((fileType: FileType) => {
                fileType.active = false;
            });
        }

        anyFilters(): boolean {
            for (let i = 0; i < this.acceptedFileTypes.length; i++) {
                if (this.acceptedFileTypes[i].active) return true;
            }
            return false;
        }

        activateFilter(fileType?: FileType): void {
            if (angular.isDefined(fileType)) {
                fileType.active = !fileType.active;
            } else {
                fileType.active = true;
            }
        }

        closeFilterBar(): void {
            this.navigationBarService.setFilterBarOpen(false);
        }

        viewItem(document: DocumentModel, $event: any): void {
            document.getDownloadUrl().then((document) => {
                if (document.dctype == "pdf") {
                    this.openInNewTab(document.downloadUrl);
                } else {
                    this.dialog.show({
                        component: "vc-view-document",
                        targetEvent: $event,
                        scope: this.$scope,
                        locals: {
                            document: document,
                        },
                        size: "large",
                    });
                }
            });
        }

        openInNewTab(url: string): void {
            let win = window.open(url, "_blank");
            win.focus();
        }

        download(document: DocumentModel, $event: any): void {
            if (document.dccompleted == "1") {
                document.getDownloadUrl().then(() => {
                    this.$timeout(() => {
                        $event.target.parentElement.parentElement
                            .getElementsByClassName("invisible_download")[0]
                            .click();
                    });
                });
            }
        }

        getFilteredDocuments(): DocumentModel[] {
            return _.filter(this.documents, (item: any) => {
                if (!this.isLeaderView || item.dccreator == this.user.uid) {
                    if (
                        this.dataProvider.allFilteredTypes(
                            this.acceptedFileTypes
                        ).length === 0 ||
                        this.dataProvider
                            .allFilteredTypes(this.acceptedFileTypes)
                            .indexOf(item.dctype.toLowerCase()) > -1
                    ) {
                        return true;
                    } else if (
                        this.acceptedFileTypes[
                            this.acceptedFileTypes.length - 1
                        ].active &&
                        this.dataProvider
                            .allFilteredTypes(this.acceptedFileTypes, true)
                            .indexOf(item.dctype.toLowerCase()) == -1
                    ) {
                        //This is checking if the filter "Other" is selected and checks that the file type doesn't match any other filters
                        return true;
                    }
                    return false;
                }
            });
        }

        deleteModal(document: DocumentModel, $event: any): void {
            this.dialog
                .delete({
                    targetEvent: $event,
                    skipHide: true,
                    clickOutsideToClose: true,
                    locals: {
                        title: `Delete ${
                            document.dcoldfilename || document.dcfilename
                        }?`,
                        bodyText: "They will be permanently deleted",
                    },
                })
                .then(() => {
                    this.dataProvider.deleteDocument(document).then(
                        () => {
                            this.toast.success(
                                `Deleted document: ${
                                    document.dcoldfilename ||
                                    document.dcfilename
                                }`
                            );
                        },
                        () => this.toast.error()
                    );
                });
        }
    },
};

angular
    .module("document", ["angularFileUpload"])
    .component(DocumentComponent.selector, DocumentComponent);
